import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ChatSummaryAPI = /** @class */ (function () {
    function ChatSummaryAPI(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ChatSummaryAPI.initialize = function (basePath, fetchApi) {
        if (!ChatSummaryAPI.instance) {
            ChatSummaryAPI.instance = new ChatSummaryAPI(basePath, fetchApi);
        }
        return ChatSummaryAPI.instance;
    };
    ChatSummaryAPI.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ChatSummaryApi(new Configuration(config));
    };
    return ChatSummaryAPI;
}());
export { ChatSummaryAPI };
